import Vue from 'vue'
import {api} from '../../api/electronic-control'
import {registerConfig} from '../../../components/common/di-ding'
import {commonConfig, routeNameOfDi} from '../common'
import {spDateFormat} from '../../../utils/util'
import inputDateHelper from '../../../components/common/inputs/_input-date-helper'
import DatePickerBox from './date-picker-box'

Vue.component('date-picker-box', DatePickerBox)

const mapping = {
  personName: {
    label: '缴费人姓名'
  },
  personPhone: {
    label: '缴费人手机号'
  },
  enterpriseName: {
    label: '所属住户'
  },
  year: {
    label: '出账年份',
    width: '100px'
  },
  month: {
    label: '出账月份',
    width: '100px'
  },
  payAmount: {
    label: '缴费金额'
  },
  payTime: {
    label: '缴费时间'
  }
}

const config = {
  breadcrumb: [{
    value: '智慧用电',
    name: 'electronic-config'
  }, {
    value: '缴费记录',
  }],
  center: {
    opBar: [ // 多少个元素代表多少行
      [ // 仅支持 flex布局
        {
          type: 'date-second',
          pickerOptions: {
            shortcuts: [
              inputDateHelper.OPTIONS.SHORTCUT.A_WEEK,
              inputDateHelper.OPTIONS.SHORTCUT.A_MONTH,
              inputDateHelper.OPTIONS.SHORTCUT.THREE_MONTHS
            ],
            disabledDate: inputDateHelper.OPTIONS.DISABLED_DATE.HENCEFORTH
          },
          default: inputDateHelper.time.todayRange,
          beforeDataIsGet ({requestBody}) {
            const [startTime, endTime] = inputDateHelper.time.todayRange()
            requestBody.startTime = spDateFormat(startTime)
            requestBody.endTime = spDateFormat(endTime)
          },
          entityInSearchRequestBody: (currentTime) => ({
            startTime: currentTime[0],
            endTime: currentTime[1]
          })
        },
        [
          {type: 'input-search', label: '姓名/学工号', searchKey: 'searchKey'},
          {
            type: 'button-download',
            label: '导出',
            getDownloadUrl: (requestBody) => api.exportElectronicRecord(requestBody),
            download: '电费缴费记录'
          }
        ]
      ],
      [
        {
          type: 'render',
          renderContent (h, type, data, that) {
            const onChange = val => {
              console.log(val)
              let chooseYear = val.split('-')[0]
              let chooseMonth = val.split('-')[1]
              that.requestBody.year = chooseYear
              that.requestBody.month = chooseMonth
              this.$emit('change')
            }
            return <date-picker-box style={{marginBottom: '14px'}}
                                    type="month" onChange={onChange}/>
          },
        },
        {
          type: 'search-selector',
          label: '缴费状态',
          searchKey: 'state',
          fetchDetail: () => Promise.resolve(
            [{
              '_value': '0',
              '_label': '未缴费'
            }, {
              '_value': '1',
              '_label': '已缴费'
            }]
          )
        }
      ]
    ],
    table: {
      operations: []
    }
  },

  get: requestBody => api.getPayRecordPage(requestBody),

  mapping
}

registerConfig(routeNameOfDi.ELECTRONIC_RECORD, config)



// WEBPACK FOOTER //
// ./src/view/ElectronicControl/electronic-record/electronic-record.js